import { render, staticRenderFns } from "./addProxy.vue?vue&type=template&id=086367c8&lang=pug&"
import script from "./addProxy.vue?vue&type=script&lang=js&"
export * from "./addProxy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports